<template>
    <div>
        <user-action-revoke-dialog
            :activatorType="activatorType"
            :showRevokeButton="showRevokeButton"
            :ucid="ucid"
            :userName="userName"
            :hierarchicalLevel="hierarchicalLevel"
            :role="role"
            :reason="reason"
            :spaceAdmin="spaceAdmin"
            :instanceName="instanceName"
            :instanceId="instanceId"
            :spaceName="spaceName"
            :orgName="orgName"></user-action-revoke-dialog>

        <user-action-deactivate-dialog
            :activatorType="activatorType"
            :showDeactivateActivateButton="showDeactivateActivateButton"
            :isActiveUser="isActiveUser"
            :uid="uid"
            :userName="userName"
            :hierarchicalLevel="hierarchicalLevel"></user-action-deactivate-dialog>

        <user-action-activate-dialog
            :activatorType="activatorType"
            :showDeactivateActivateButton="showDeactivateActivateButton"
            :isActiveUser="isActiveUser"
            :uid="uid"
            :userName="userName"
            :hierarchicalLevel="hierarchicalLevel"></user-action-activate-dialog>
    </div>
</template>

<script>
const UserActionRevokeDialog = () => import('@/components/UserActionRevokeDialog.vue')
const UserActionDeactivateDialog = () => import('@/components/UserActionDeactivateDialog.vue')
const UserActionActivateDialog = () => import('@/components/UserActionActivateDialog.vue')

export default {
    name: 'UserActions',
    components: {
        UserActionRevokeDialog,
        UserActionDeactivateDialog,
        UserActionActivateDialog
    },
    props: {
        uid: String,
        ucid: String,
        userName: String,
        hierarchicalLevel: String,
        isActiveUser: Boolean,
        role: String,
        reason: {
            type: String,
            default: null
        },
        spaceAdmin: {
            type: Boolean,
            default: null
        },
        showRevokeButton: {
            type: Boolean,
            default: true
        },
        showDeactivateActivateButton: {
            type: Boolean,
            default: true
        },
        activatorType: {
            type: String,
            default: 'icon'
        },
        instanceName: {
            type: String,
            default: null
        },
        instanceId: {
            type: String,
            default: null
        },
        spaceName: {
            type: String,
            default: null
        },
        orgName: {
            type: String,
            default: null
        }
    }
}
</script>
